// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2WMFk","inputDescription":"styles_inputDescription__nJ7tF"};